/* eslint-disable */
import {blueThemeDark} from '../theme/theme'


export const themeData = {
    theme: blueThemeDark
}

